// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".listing-filters-clear-all[data-v-32c9c4f4]{width:100%;position:relative;display:grid;-webkit-box-align:center;-ms-flex-align:center;align-items:center;justify-items:center;text-align:center}.listing-filters-clear-all-link[data-v-32c9c4f4]{width:100%;padding:5px;background:#ffebeb;border-radius:5px}", ""]);
// Exports
module.exports = exports;
